import React from 'react'
import NewsStrip from '../../../components/NewsStrip'

const NewsStripWidget = ({ items, dismissId }) => (
  <NewsStrip items={items} dismissId={dismissId} />
)

export default NewsStripWidget
